<section class="due-survey-dialog">
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <h2 class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8 uscb-title-3 uscb-color-white">
            Calendar Export</h2>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <mat-dialog-content>
        <div class="my-dialog-content uscb-layout-column uscb-layout-align-center-center">
            @if (isExporting()) {
            <div class="cursor-progress"> Please wait. Exporting... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i></div>
            }
        </div>
    </mat-dialog-content>
</section>
